import type { MisconceptionDefinition } from '../types'

/** REK — Cijferend rekenen + voorrangsregels (slice 1). */
export const cijferenVolgordeMisconceptions: MisconceptionDefinition[] = [
  {
    id: 'rek.carry-forgotten',
    label: 'Onthouden vergeten',
    module: 'Basisrekenen',
    description:
      'Leerling vergeet de overdracht (carry) volledig bij cijferend optellen of vermenigvuldigen — schrijft géén onthoud-cijfer op of telt het in de volgende kolom niet mee. Onderscheid met rek.carry-wrong-value: dáár wordt wél een overdracht meegerekend, maar met het verkeerde cijfer.',
    typicalFamilies: ['REK-CIJF-PLUS', 'REK-CIJF-KEER'],
  },
  {
    id: 'rek.borrow-forgotten',
    label: 'Lenen vergeten',
    module: 'Basisrekenen',
    description:
      'Leerling weet dat aftrekken nodig is maar voert het leen-mechanisme niet (volledig) uit: vergeet het tiental boven te verlagen of het geleende tiental bij de eenheden op te tellen. Onderscheid met rek.subtract-reversed: dáár denkt de leerling dat aftrekken per kolom commutatief is en draait de bewerking om.',
    typicalFamilies: ['REK-CIJF-MIN'],
  },
  {
    id: 'rek.order-of-operations',
    label: 'Voorrangsregels niet toegepast',
    module: 'Basisrekenen',
    description:
      'Leerling past de voorrangsregels (eerst haakjes, dan × en ÷ van links naar rechts, dan + en − van links naar rechts) niet of niet volledig toe. Vaak gecombineerd met rek.left-to-right (gewoon van links naar rechts uitrekenen) of rek.brackets-ignored.',
    typicalFamilies: ['REK-VOLGORDE'],
  },
  {
    id: 'rek.multiplication-table-error',
    label: 'Tafelfout',
    module: 'Basisrekenen',
    description:
      'Leerling kent een specifieke tafel niet uit het hoofd (bijv. 7×8=54).',
    typicalFamilies: [
      'REK-TAFELS-BASIS',
      'REK-TAFELS-UITBREIDEN',
      'REK-TAFELS-TOEPASSEN',
    ],
  },
  {
    id: 'rek.division-remainder-ignored',
    label: 'Rest genegeerd',
    module: 'Basisrekenen',
    description:
      'Leerling negeert de rest bij een deling of rondt verkeerd af.',
    typicalFamilies: ['REK-CIJF-DEEL'],
  },
  {
    id: 'rek.subtract-reversed',
    label: 'Aftrekken omgedraaid',
    module: 'Basisrekenen',
    description:
      'Leerling behandelt aftrekken per kolom alsof het commutatief is en trekt het kleinste cijfer van het grootste af, ongeacht boven/onder. Dit is een conceptuele fout (denkt dat 4−7 onmogelijk is dus rekent 7−4), niet enkel een uitvoeringsfout.',
    typicalFamilies: ['REK-CIJF-MIN'],
  },
  {
    id: 'rek.negative-written',
    label: 'Negatief getal opgeschreven',
    module: 'Basisrekenen',
    description:
      'Leerling schrijft een negatief getal op in plaats van te lenen bij aftrekken.',
    typicalFamilies: ['REK-CIJF-MIN'],
  },
  {
    id: 'rek.column-skipped',
    label: 'Kolom overgeslagen',
    module: 'Basisrekenen',
    description: 'Leerling slaat een kolom over bij cijferend rekenen.',
    typicalFamilies: ['REK-CIJF-MIN', 'REK-CIJF-PLUS'],
  },
  {
    id: 'rek.column-misalignment',
    label: 'Kolommen verkeerd uitgelijnd',
    module: 'Basisrekenen',
    description:
      'Leerling schrijft de cijfers in de verkeerde kolom (eenheden onder tientallen, of komma niet uitgelijnd), waardoor de plaatswaarde verschuift en alle tussenresultaten fout worden.',
    typicalFamilies: ['REK-CIJF-PLUS', 'REK-CIJF-MIN', 'REK-CIJF-KEER'],
  },
  {
    id: 'rek.carry-wrong-value',
    label: 'Verkeerd getal onthouden',
    module: 'Basisrekenen',
    description:
      'Leerling onthoudt het verkeerde getal bij de overdracht (bijv. eenheden i.p.v. tientallen).',
    typicalFamilies: ['REK-CIJF-PLUS', 'REK-CIJF-KEER'],
  },
  {
    id: 'rek.left-to-right',
    label: 'Links-naar-rechts zonder voorrang',
    module: 'Basisrekenen',
    description:
      'Leerling rekent van links naar rechts zonder de bewerkingsvolgorde toe te passen.',
    typicalFamilies: ['REK-VOLGORDE'],
  },
  {
    id: 'rek.brackets-ignored',
    label: 'Haakjes genegeerd',
    module: 'Basisrekenen',
    description:
      'Leerling negeert haakjes en past de standaard voorrangsregels toe.',
    typicalFamilies: ['REK-VOLGORDE'],
  },
]
